<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Settings') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/menus/AccountantsSubmenu.vue'

export default {
  name: 'AccountantsDashboardMenu',
  components: { AccountantsSubmenu },
  computed: {
    menuItems() {
      return [
        {
          key: 'company-details',
          label: this.$gettext('Main Dashboard'),
          name: 'AccountantsDashboard',
          icon: 'fa-briefcase',
        },
        // {
        //   key: 'personal-profile',
        //   label: 'Journals',
        //   name: 'AccountantProfileSettings',
        //   icon: 'fa-gear',
        // }
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
